import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { GiftBanner } from "@/components/GiftBanner";
import { ScrollToTop } from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Lessons from "@/pages/Lessons";
import Intensive from "@/pages/Intensive";
import ParentInfo from "@/pages/ParentInfo";
import Policies from "@/pages/Policies";
import UnderwaterVideos from "@/pages/UnderwaterVideos";
import SwimBooks from "@/pages/SwimBooks";
import Testimonials from "@/pages/Testimonials";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Merch from "@/pages/Merch";
import AdminPreOrders from "@/pages/AdminPreOrders";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/lessons" element={<Lessons />} />
            <Route path="/intensive" element={<Intensive />} />
            <Route path="/parent-info" element={<ParentInfo />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/underwater-videos" element={<UnderwaterVideos />} />
            <Route path="/swim-books" element={<SwimBooks />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/admin/pre-orders" element={<AdminPreOrders />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <Footer />
        <GiftBanner />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
